/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  CreateInstanceRequestBody,
  CreateInstanceRequestBody$Outbound,
  CreateInstanceRequestBody$outboundSchema,
} from "../components/createinstancerequestbody.js";

export type CreateLiteLLMInstanceSecurity = {
  projectSlugHeaderGramProject?: string | undefined;
  sessionHeaderGramSession?: string | undefined;
};

export type CreateLiteLLMInstanceRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
  createInstanceRequestBody: CreateInstanceRequestBody;
};

/** @internal */
export type CreateLiteLLMInstanceSecurity$Outbound = {
  "project_slug_header_Gram-Project"?: string | undefined;
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const CreateLiteLLMInstanceSecurity$outboundSchema: z.ZodMiniType<
  CreateLiteLLMInstanceSecurity$Outbound,
  CreateLiteLLMInstanceSecurity
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.optional(z.string()),
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function createLiteLLMInstanceSecurityToJSON(
  createLiteLLMInstanceSecurity: CreateLiteLLMInstanceSecurity,
): string {
  return JSON.stringify(
    CreateLiteLLMInstanceSecurity$outboundSchema.parse(
      createLiteLLMInstanceSecurity,
    ),
  );
}

/** @internal */
export type CreateLiteLLMInstanceRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  "Gram-Project"?: string | undefined;
  CreateInstanceRequestBody: CreateInstanceRequestBody$Outbound;
};

/** @internal */
export const CreateLiteLLMInstanceRequest$outboundSchema: z.ZodMiniType<
  CreateLiteLLMInstanceRequest$Outbound,
  CreateLiteLLMInstanceRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
    gramProject: z.optional(z.string()),
    createInstanceRequestBody: CreateInstanceRequestBody$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      gramProject: "Gram-Project",
      createInstanceRequestBody: "CreateInstanceRequestBody",
    });
  }),
);

export function createLiteLLMInstanceRequestToJSON(
  createLiteLLMInstanceRequest: CreateLiteLLMInstanceRequest,
): string {
  return JSON.stringify(
    CreateLiteLLMInstanceRequest$outboundSchema.parse(
      createLiteLLMInstanceRequest,
    ),
  );
}
